import { Text } from "@fluentui/react-components";
import { InfoRegular } from "@fluentui/react-icons";
import { useAtom, useAtomValue } from "jotai";
import { EApprovalStatus, EBenefitContentTab, EFilterStatusType } from "library/types";
import { Trans, useTranslation } from "react-i18next";
import { selectedCategoryFilterAtom, selectedStatusFilterAtom } from "store";
import { benefitContentTabAtom } from "store/UIBenefitsPage";
import styled from "styled-components";

import { BenefitCard } from "components/BenefitCard/BenefitCard";
import { CardListWrap } from "components/styled";
import { useBenefitsData } from "hooks/useBenefitsData";

export function EnrolledPackages() {
  const { enrolledFilteredData } = useBenefitsData();

  const { t } = useTranslation();
  const [selectedTabContent, setSelectedContentTab] = useAtom(benefitContentTabAtom);
  const categoryFilters = useAtomValue(selectedCategoryFilterAtom);
  const statusFilters = useAtomValue(selectedStatusFilterAtom);
  const selectedContentTab = useAtomValue(benefitContentTabAtom);

  return (
    <>
      {enrolledFilteredData?.length ? (
        <CardListWrap>
          {enrolledFilteredData
            .filter((benefit) => {
              const categoryFilterPassed = categoryFilters[selectedContentTab]?.find(
                (filter) => Number(filter.id) === benefit.benefitCategoryTag
              );

              const hasPendingStatus =
                benefit?.cancelEnrollApprovalStatusCode === EApprovalStatus.PENDING;
              const requiresCancellationApproval = benefit?.requiresCancellationApproval;
              const waitingForCancellation =
                requiresCancellationApproval && !!benefit?.dateOfCancellation && hasPendingStatus;

              const inReviewFilterSelected = statusFilters[selectedContentTab]?.find(
                (filter) => filter.id === EFilterStatusType.IN_REVIEW
              );

              const inReviewFilterPassed = inReviewFilterSelected ? waitingForCancellation : true;

              return categoryFilterPassed && inReviewFilterPassed;
            })
            .map((benefit) => {
              const hasPendingStatus =
                benefit?.cancelEnrollApprovalStatusCode === EApprovalStatus.PENDING;
              const requiresCancellationApproval = benefit?.requiresCancellationApproval;
              const waitingForCancellation =
                requiresCancellationApproval && !!benefit?.dateOfCancellation && hasPendingStatus;

              return (
                <BenefitCard
                  waitingForCancel={waitingForCancellation}
                  selected
                  key={benefit.benefitPackageTag}
                  benefitPackage={benefit}
                />
              );
            })}
        </CardListWrap>
      ) : selectedTabContent === EBenefitContentTab.enrolled ? (
        <NoEnrolledBenefitsText>
          <div>
            <InfoRegular fontSize={18} />
          </div>
          <Text weight="semibold" block>
            <Trans
              t={t}
              i18nKey={"hbh.noEnrolledBenefits.label"}
              components={[
                <LinkToEligible
                  onClick={() => {
                    setSelectedContentTab(EBenefitContentTab.eligible);
                  }}
                />,
              ]}
            />
          </Text>
        </NoEnrolledBenefitsText>
      ) : null}
    </>
  );
}

const NoEnrolledBenefitsText = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px;
  max-width: 600px;
`;

const LinkToEligible = styled.span`
  color: ${({ theme }) => theme.palette.green};
  text-decoration: underline;
  cursor: pointer;
`;
